import { useEffect, useState } from 'react';

export const useFocusFunctionality = () => {
  const [focusElement, setFocusedElement] = useState<string>(null);

  useEffect(() => {
    if (focusElement) {
      document.getElementById(focusElement)?.focus();
      setFocusedElement(null);
    }
  }, [focusElement]);

  return { focusElement, setFocusedElement };
};
